<template>
  <ScanView/>
</template>

<script>
import ScanView from "../components/Scanner/Widgets/ScanView";

export default {
  name: 'Masque',
  components: {
    ScanView,
  },
  data() {
    return {}
  },
  mounted() {
  }
}
</script>